export default __webpack_public_path__ + "static/media/villa.6fdc5927.jpg";